import { Component, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../DialogResult";
import { Observable } from "rxjs";

export interface InputEditDialogData {
  title: string;
  prompt: string;
  data: string;
}

@Component({
  selector: "input-edit-dialog",
  styleUrls: ["./input-edit-dialog.component.html"],
  templateUrl: "./input-edit-dialog.component.html",
})
export class InputEditDialogComponent {
  public Result: DialogResult;
  public CurrentData: string;

  constructor(
    public dialogRef: MatDialogRef<InputEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InputEditDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
    this.CurrentData = data.data;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.CurrentData;
    this.dialogRef.close(this.Result);
  }

  static showDialog(
    dialog: MatDialog,
    title: string,
    prompt: string,
    data: string
  ): Observable<any> {
    var params: InputEditDialogData = {
      title: title,
      prompt: prompt,
      data: data
    };

    var dialogRef = dialog.open(InputEditDialogComponent, {
      disableClose: true,
      width: "500px",
      data: params,
    });

    return dialogRef.afterClosed();
  }
}
